<template>
  <div class="container">
    <div class="row" v-if="showExplanation">
      <p>
        This tool aims to identify raptures missed due to premature eraption of shields. To use, please input your log with your priest selected, together with your spellpower. If you are wearing 4PT8, please add 250 to the spellpower field. Note that this tool only runs on single fights.
      </p>
      <p>
        We are not passing value judgement on premature eraption. Sacrificing a rapture chain to save a raid member is sometimes the correct play, and it is up to the player to decide how to utilise the information provided.
      </p>
    </div>

    <div class="row">
      <div class="input-group mb-2" style="width: 100%">
        <input type="text" class="form-control" v-model.number="wclLink" placeholder="Paste WCL Link">
      </div>
<!--       <div class="input-group mb-2" style="width: 100%">
        <span class="input-group-text" id="basic-addon1"
        v-b-tooltip.hover title="Max rank PWS values are calculated based off inputted spellpower.">Spellpower</span>
        <input type="text" class="form-control" v-model.number="spellPower">
      </div>

      <div class="input-group mb-2" style="width: 100%">
        <span class="input-group-text" id="basic-addon1"
        v-b-tooltip.hover title="Only raptures that results in a minimum number of procs will be considered.">Min raptures procs</span>
        <input type="text" class="form-control" v-model.number="hitsThreshold">
      </div> -->
      <button v-if="!fetching" @click="run" class="btn btn-primary">Analyze</button>
      <button v-if="fetching" @click="run" class="btn btn-primary">Analyzing.......</button>
    </div>
    <div class="row mt-4" v-if="showExplanation">
      <p><b>Implementation Notes</b></p>
      <ul>
        <li>Only max rank PWS are considered, and there might be differences in raptures shown from the <b>Rapture Analyzer</b> for abilities that are very close to being fully absorbed by a max-rank PWS. An example would be Freya's Unstable Energy, where any sort of partial resist would not break shields.</li>
        <li>
          For Actual Raptures, the "max" is calculated based on the total number of aoe attacks that could potentially break a full shield. However, it's possible that the actual number of raptures could exceed this due to batching of numerous small attacks).
        </li>
      </ul>
    </div>

    <div class="row margin-top-40" v-if="results && !fetching">
      <h5 style="width: 100%">Select other fights</h5>
      <v-select v-if="results" style="width: 100%"
        :options="results['otherFightOptions']" v-model="currentFightId"
        :reduce="fight => fight.fightId"
        label="label"
      >
      </v-select>      
    </div>

    <div v-if="results && results['data'].length > 0" class="container margin-top-40 no-pad-left">
      <div class="row">
        <p>
          The player's actual raptures are shown on the left, while missed opportunities are shown on the right. A border indicates a rapture is selected (only opportunities associated to this rapture will be shown), and click on other actual raptures to cycle through.
        </p>
        <p>
          <b>IMPORTANT: only AOE attacks that can one shot a full rank PWS shield is considered an opportunity (e.g. ignis flame jets might not appear if your spellpower is high). </b>
        </p>
        <p>
          Missed opportunities that are within the rapture ICD and greatly outnumber the number of hits of the actual rapture will be shaded red.
        </p>
        <div class="col-md-4">
          <h5>Actual Raptures</h5>
          <ul>
            
            <!-- poor code to use 5 - this meant to be  MIN_DIFFERENCE_TO_SHADE-->
            <!-- but can't use constants in tempaltes -->
            <!-- for missed -  we use maxAmount rather than amount
            because if lets say we only captured 5 raptures from ground tremor (potential of 25), and thus missed a 10 proc sunbeam, it's still the right move
             -->
            <li
                v-for="(row, index) in results['data']" :key="index"
                :class="{selected: index === selectedRaptureIndex, missed: row['opportunitiesMaxAmount'] > row['maxAmount'] + 5}"
                @click="selectedRaptureIndex = index">
              <p v-if="row['amount'] > 1">
                <b>{{ row['timestamp'] }}s: {{ row['amount'] }} raptures (max: {{ row['maxAmount'] }})</b>
                <br><i>{{ row['abilityCausingProc'].join(', ') }}</i>
                <br>
                <span v-if="row['opportunitiesMaxAmount'] && row['amount'] < row['opportunitiesMaxAmount']">
                  Missed: {{ row['opportunitiesMaxAmount'] }} proc chance
                </span>
              </p>
              <p v-else>
                <b>{{ row['timestamp'] }}s: 1 rapture ({{ row['proccers'][0] }})</b>
                <br><i>{{ row['abilityCausingProc'].join(', ') }}</i>
                <br>
                <span v-if="row['opportunitiesMaxAmount'] && row['amount'] < row['opportunitiesMaxAmount']">
                  Missed: {{ row['opportunitiesMaxAmount'] }} proc chance
                </span>
              </p>
            </li>
          </ul>
        </div>
        <div class="col-md-8">
          <h5>Opportunities</h5>
          <b-table :items="tableData" :fields="fields"></b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';

const COLOR_VARIANTS = ['danger', 'primary', 'success', 'warning', 'info', 'light', 'dark'];

export default {
  name: 'AlgalonAnalyzer',
  metaInfo: {
    title: 'Algalon Analyzer',
  },
  data() {
    return {
      showExplanation: true,
      fetching: false,
      wclLink: '',
      results: null,
      currentFightId: '',
    };
  },
  watch: {
    currentFightId(newVal, oldVal) {
      // we only want to repull when user has already run once, and is selecting from select input
      if (oldVal === '' || isNaN(oldVal) || newVal === oldVal) return;
      // console.log(oldVal, newVal);
      this.runHelper(newVal);
    },
  },
  computed: {
    tableData() {
      return [];
    //   let opportunities = this.results['data'][this.selectedRaptureIndex]['opportunities'];
    //   let actualRaptureHits = this.results['data'][this.selectedRaptureIndex]['amount'];
    //   for (let opportunity of opportunities) {
    //     if (opportunity['withinRaptureICD'] && opportunity['numHits'] > actualRaptureHits + MIN_DIFFERENCE_TO_SHADE) {
    //       opportunity['_rowVariant'] = 'danger';
    //     }
    //   }
    // //   // we want to ensure that the key colors are taken by abilities that appear at the top (hence need rank -> hits)
    // //   let colorMap = {},
    // //     colorIndex = 0;
    // //   for (let j = 0; j < data.length; j++) {
    // //     let name = data[j]['name']
    // //     if (!(name in colorMap)) {
    // //       // assigns a color; if we run out of colors, then use 'dark'
    // //       colorMap[name] = (colorIndex < COLOR_VARIANTS.length - 1) ? COLOR_VARIANTS[colorIndex++] : 'dark';
    // //     }
    // //     data[j]['_rowVariant'] = colorMap[name];
    // //   }


    // //   if (!this.showHighDamageItemsOnly) return data;
    // //   return data.filter((entry) => {
    // //     return (Number(entry['avgDamageTaken']) >= this.damageThreshold) && (Number(entry['numHits']) >= this.hitsThreshold);
    // //   });
    //   return opportunities;
    }
  },
  methods: {
    // if a specific fight id is passed, then we use that, regardless of what the fight id is on the wcl link
    runHelper(specificFightId=null) {
      this.fetching = true;
      this.results = null;
      let toPass = {wclLink: this.wclLink};
      if (specificFightId) {
        toPass['fightId'] = specificFightId;
      }

      axios
          .post(`analyzer/misc/algalon`, toPass)
          .then((response) => {
            this.fetching = false;
            console.log(response.data);
            this.results = response.data;
            this.currentFightId = Number(response.data['currentFightId']);
            this.showExplanation = false;
          })
          .catch((error)  => {
            alert(error.response.data.message);
            this.fetching = false;
            this.showExplanation = false;
          });
    },
    run() {
      if (this.fetching) return;
      if (this.wclLink.indexOf('fight=') === -1) {
          alert("Invalid URL link - make sure 'fight=yy' is in the link");
          return;
      }

      if (this.wclLink.indexOf('source=') > -1) {
          alert("Invalid URL link - make sure 'source=yy' is not in the link");
          return;
      }
      this.runHelper();
    }
  },
  mounted() {
    console.log('mounting');
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.no-pad-left {
  padding-left: 0px;
}

.margin-top-40 {
  margin-top: 40px;
}

ul {
  list-style: none;
  padding-left: 0px;
  height: 600px;
  overflow: scroll;
}

li {
  cursor: pointer;
  padding: 10px 10px
}

li.selected {
  border: 5px #00b1ff;
  border-style: dashed;
}

li.missed {
  background: #f5c6cb;
}

li p {
  padding: 0px;
  margin: 0px;
}

/*background: #72ff0f;*/
</style>
